import { useState } from "react";
import styles from "./styles.module.scss";

export const Tabs = ({ activeTab, setActiveTab, tabsArr }) => {
  function handleClickTab(tab) {
    setActiveTab(tab.key);
  }

  return (
    <div className={styles.tabsContainer}>
      <div className={styles.tabs}>
        {tabsArr.map(({ Icon, ...tab }) => (
          <div
            className={
              styles[
                `${tab.key === activeTab ? "activeSingleTab" : "singleTab"}`
              ]
            }
            key={tab.key}
            onClick={() => handleClickTab(tab)}
          >
            <Icon
              color={
                tab.key === activeTab ? tab.activeColor : tab.inactiveColor
              }
            />
            {tab.title}
          </div>
        ))}
      </div>
    </div>
  );
};
